// These values are the same as light, but we keep a hard copy
// so that we can always change these values if they need to be different

export const opacity = {
  dark: {
    600: 'rgba(0,0,0,0.6)',
    400: 'rgba(255,255,255,0.4)',
    250: 'rgba(255,255,255,0.25)',
    80: 'rgba(255,255,255,0.08)',
    50: 'rgba(255,255,255,0.05)',
  },
  light: {
    500: 'rgba(0,0,0,0.5)',
    400: 'rgba(0,0,0,0.4)',
    250: 'rgba(0,0,0,0.25)',
    80: 'rgba(0,0,0,0.08)',
    50: 'rgba(0,0,0,0.05)',
  },
  primary: {
    600: 'rgba(215,52,49,0.6)',
    500: 'rgba(215,52,49,0.5)',
    400: 'rgba(215,52,49,0.4)',
    250: 'rgba(215,52,49,0.25)',
    200: 'rgba(215,52,49,0.2)',
    150: 'rgba(215,52,49,0.15)',
    100: 'rgba(215,52,49,0.1)',
    80: 'rgba(215,52,49,0.08)',
    50: 'rgba(215,52,49,0.05)',
  },
}
